<template>
    <section class="space-section" id="customers-section" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" data-aos-anchor-placement="top-center">
      <b-row class="justify-content-center">
        <b-col cols="12" sm="12" md="12" lg="12" xl="10">
          <div>
            <!-- <h5 class="text-center title-section-c">{{ $t('header.customers') }}</h5>
            <p class="text-center content-section">Actualmente, Marabunta extiende los departamentos de diseño, desarrollo y marketing de nuevas empresas en crecimiento, compañías altamente reconocidas, figuras públicas y clientes internacionales.</p> -->

            <h5 class="text-center gotham-med tm-title">{{ $t('header.customers') }}</h5>
            <p class="text-center gotham-book tm-content">{{ $t('customers.content') }}</p>
          </div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="12" sm="12" md="12" lg="12" xl="12">
          <div class="div-customers-t">
            <div class="customer" id="customer1"></div>
            <div class="customer" id="customer2"></div>
            <div class="customer" id="customer26"></div>
            <div class="customer" id="customer3"></div>
            <div class="customer" id="customer27"></div>
            <!-- <div class="customer" id="customer4"></div> -->
            <div class="customer" id="customer5"></div>
            <div class="customer" id="customer6"></div>
            <div class="customer" id="customer28"></div>
            <div class="customer" id="customer7"></div>
            <div class="customer" id="customer8"></div>
            <div class="customer" id="customer29"></div>
            <div class="customer" id="customer9"></div>
            <div class="customer" id="customer10"></div>
            <div class="customer" id="customer13"></div>
            <div class="customer" id="customer11"></div>
            <div class="customer" id="customer30"></div>
            <div class="customer" id="customer16"></div>
            <div class="customer" id="customer23"></div>

            <!-- <div class="customer" id="customer12"><p>IOT LAB</p></div> -->
            <!-- <div class="customer" id="customer14"><p>ISABEL MOLINA</p></div> -->
            <!--  -->
            <div class="customer" id="customer17"></div>
            <div class="customer" id="customer24"></div>
            <div class="customer" id="customer18"></div>
            <div class="customer" id="customer19"></div>
            <div class="customer" id="customer15"></div>
            <div class="customer" id="customer20"></div>
            <div class="customer" id="customer21"></div>
            <div class="customer" id="customer25"></div>
            <div class="customer" id="customer22"></div>
            <!-- <div class="customer" id="customer25"></div> -->
          </div>
        </b-col>
      </b-row>

    </section>
</template>

<script>
export default {
  name: 'Customers'
}
</script>

<style>

.gotham-med{
  font-family: 'Gotham Medium Regular';
}

.title-section-c{

  font-family: 'Gotham Medium Regular';
  letter-spacing: 2.46px !important;
  font-size: 32px !important;
  line-height: 36px !important;
  text-align: center;
  color: #1D2B3C;
}
.content-section{

  font-family: 'Gotham Book Regular';
  letter-spacing: 1.54px !important;
  font-size: 20px !important;
  line-height: 28px !important;
  text-align: center;
  color: #1D1D1D;
  margin-top: 3%;
}
.div-customers-t{
  display: flex;
  /* justify-content: space-between;  */
  flex-flow: row wrap;
  justify-content: center;
  /* justify-items: center; */
}
.customer{
  margin-top: 3%;
  width: 350px;
  height: 140px;
  background-repeat: no-repeat;
  background-position:center;
  align-content: center;
}

.customer:hover{
  transform: scale(1.2);
}
#customer1{
  background-image: url(../assets/img/Logo2Tor_Gris.png);
   background-size:154px 154px;
}
#customer1:hover{
  background-image: url(../assets/img/Logo2Tor_Color.jpg);
   background-size:154px 154px;
}
#customer2{
  background-image: url(../assets/img/LogoAruba_Gris.png);
   background-size:225px 61px;
}
#customer2:hover{
  background-image: url(../assets/img/LogoAruba_Color.png);
   background-size:225px 61px;
}
#customer3{
  background-image: url(../assets/img/LogoBeSchool_Gris.png);
  background-size:134px 134px;
}
#customer3:hover{
  background-image: url(../assets/img/LogoBeSchool_Color.png);
  background-size:134px 134px;
}
#customer4{
  background-image: url(../assets/img/LogoChefTete_Gris.png);
  background-size:250px 60px;
}
#customer4:hover{
  background-image: url(../assets/img/LogoChefTete_Color.png);
  background-size:250px 60px;
}
#customer5{
  background-image: url(../assets/img/LogoCSA_Gris.png);
  background-size:120px 50px;
}
#customer5:hover{
  background-image: url(../assets/img/LogoCSA_Color.png);
  background-size:120px 50px;
  background-color: #5c565627;
}
#customer6{
  background-image: url(../assets/img/LogoCustosMobile_Gris.png);
  background-size:304px 304px;
}
#customer6:hover{
  background-image: url(../assets/img/LogoCustosMobile_Color.png);
  background-size:304px 304px;
}
#customer7{
  background-image: url(../assets/img/LogoEglobal_Gris.png);
  background-size:251px 70px;
}
#customer7:hover{
  background-image: url(../assets/img/LogoEglobal_Color.png);
  background-size:251px 70px;
}
#customer8{
  background-image: url(../assets/img/LogoExitusCredit_Gris.png);
  background-size:236px 52px;
}
#customer8:hover{
  background-image: url(../assets/img/LogoExitusCredit_Color.png);
  background-size:236px 52px;
}
#customer9{
  background-image: url(../assets/img/LogoExitusMujer_Gris.png);
  background-size:241px 136px;
}
#customer9:hover{
  background-image: url(../assets/img/LogoExitusMujer_Color.png);
  background-size:241px 136px;
}
#customer10{
  background-image: url(../assets/img/LogoExos_Gris.png);
  background-size:190px 79px;
}
#customer10:hover{
  background-image: url(../assets/img/LogoExos_Color.png);
  background-size:190px 79px;
}
#customer11{
  background-image: url(../assets/img/LogoIbillete_Gris.png);
  background-size:256px 63px;
}
#customer11:hover{
  background-image: url(../assets/img/LogoIbillete_Color.png);
  background-size:256px 63px;
}
/* #customer12 p{
  font-family: 'Gotham Bold Regular';
  letter-spacing: 2.46px !important;
  font-size: 32px !important;
  line-height: 36px !important;
  text-align: center;
  color: #1D2B3C;
  justify-content: center;
  margin-top: 20%;

} */
#customer13{
  background-image: url(../assets/img/LogoVEQ_Gris.png);
  background-size:239px 109px;
}
#customer13:hover{
  background-image: url(../assets/img/LogoVEQ_Color.png);
  background-size:239px 109px;
}
/* #customer14 p{
  font-family: 'Gotham Bold Regular';
  letter-spacing: 2.46px !important;
  font-size: 32px !important;
  line-height: 36px !important;
  text-align: center;
  color: #1D2B3C;
  justify-content: center;
  margin-top: 20%;
} */
#customer15{
  background-image: url(../assets/img/LogoVEQCapital_Gris.png);
  background-size:226px 103px;
}
#customer15:hover{
  background-image: url(../assets/img/LogoVEQCapital_Color.png);
  background-size:226px 103px;
}
#customer16{
  background-image: url(../assets/img/LogoMastercard_Gris.png);
  background-size:181px 148px;
}
#customer16:hover{
  background-image: url(../assets/img/LogoMastercard_Color.png);
  background-size:181px 148px;
}
#customer17{
  background-image: url(../assets/img/LogoProsa_Gris.png);
  background-size:250px 76px;
}
#customer17:hover{
  background-image: url(../assets/img/LogoProsa_Color.png);
  background-size:250px 76px;
}
#customer18{
  background-image: url(../assets/img/LogoTelmex_Gris.png);
  background-size:243px 37px;
}
#customer18:hover{
  background-image: url(../assets/img/LogoTelmex_Color.png);
  background-size:243px 37px;
}
#customer19{
  background-image: url(../assets/img/LogoUbuken_Gris.png);
  background-size:231px 81px;
}
#customer19:hover{
  background-image: url(../assets/img/LogoUbuken_Color.png);
  background-size:231px 81px;
}
#customer20{
  background-image: url(../assets/img/LogoWeConnect_Gris.png);
  background-size:250px 30px;
}
#customer20:hover{
  background-image: url(../assets/img/LogoWeConnect_Color.png);
  background-size:250px 30px;
}
#customer21{
  background-image: url(../assets/img/LogoWhitecarrot_Gris.png);
  background-size:256px 108px;
}
#customer21:hover{
  background-image: url(../assets/img/LogoWhitecarrot_Color.png);
  background-size:256px 108px;
}
#customer22{
  background-image: url(../assets/img/LogoXbatt_Gris.png);
  background-size:243px 110px;
}
#customer22:hover{
  background-image: url(../assets/img/LogoXbatt_Color.png);
  background-size:243px 110px;
}
#customer23{
  background-image: url(../assets/img/LogoPROASA_Gris.png);
  background-size:259px 84px;
}
#customer23:hover{
  background-image: url(../assets/img/LogoPROASA_Color.png);
  background-size:259px 84px;
}
#customer24{
  background-image: url(../assets/img/LogoSportsCapital_Gris.png);
  background-size:173px 138px;
}
#customer24:hover{
  background-image: url(../assets/img/LogoSportsCapital_Color.png);
  background-size:173px 138px;
}
#customer25{
  background-image: url(../assets/img/LogoWomenInvestment_Gris.png);
  background-size:243px 110px;
}
#customer25:hover{
  background-image: url(../assets/img/LogoWomenInvestment_Color.png);
  background-size:243px 110px;
}
#customer26{
  background-image: url(../assets/img/BNDCR-G.png);
  background-size:220px 85px;
}
#customer26:hover{
  background-image: url(../assets/img/BNDCR-C.png);
  background-size:220px 85px;
}
#customer27{
  background-image: url(../assets/img/ConceptoMovil-G.png);
  background-size:230px 48px;
}
#customer27:hover{
  background-image: url(../assets/img/ConceptoMovil-C.png);
  background-size:236px 50px;
}
#customer28{
  background-image: url(../assets/img/Egesio-G.png);
  background-size:191px 116px;
}
#customer28:hover{
  background-image: url(../assets/img/Egesio-C.png);
  background-size:190px 115px;
}
#customer29{
  background-image: url(../assets/img/ExitusForce-G.png);
  background-size:220px 110px;
}
#customer29:hover{
  background-image: url(../assets/img/ExitusForce-C.png);
  background-size:224px 112px;
}
#customer30{
  background-image: url(../assets/img/LaCasaDeToño-G.png);
  background-size:180px 118px;
}
#customer30:hover{
  background-image: url(../assets/img/LaCasaDeToño-C.png);
  background-size:185px 124px;
}

@media screen and (max-width: 960px) and (min-width: 100px){

  .title-section-c{

    font-family: 'Gotham Light Regular';
    letter-spacing: 1.39px !important;
    font-size: 18px !important;
    line-height: 26px !important;
    text-align: center;
    color: #1D2B3C;
  }
  .content-section{

    font-family: 'Gotham Book Regular';
    letter-spacing: 1.16px !important;
    font-size: 15px !important;
    line-height: 23px !important;
    text-align: center;
    color: #1D1D1D;
  }
  .div-customers-t{
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
  }
  .customer{
    width: 120px;
    height: 100px;
    background-repeat: no-repeat;
    background-position:center;
    align-content: center;
  }
  #customer1{
    background-image: url(../assets/img/Logo2Tor_Gris.png);
    background-size:63px 63px;
    /* background-color: red; */
  }
  #customer1:hover{
    background-image: url(../assets/img/Logo2Tor_Color.jpg);
    background-size:63px 63px;
  }
  #customer2{
    background-image: url(../assets/img/LogoAruba_Gris.png);
    background-size:86px 24px;
  }
  #customer2:hover{
    background-image: url(../assets/img/LogoAruba_Color.png);
    background-size:86px 24px;
  }
  #customer3{
    background-image: url(../assets/img/LogoBeSchool_Gris.png);
    background-size:54px 54px;
  }
  #customer3:hover{
    background-image: url(../assets/img/LogoBeSchool_Color.png);
    background-size:54px 54px;
  }
  #customer4{
    background-image: url(../assets/img/LogoChefTete_Gris.png);
    background-size:83px 23px;
  }
  #customer4:hover{
    background-image: url(../assets/img/LogoChefTete_Color.png);
    background-size:83px 23px;
  }
  #customer5{
    background-image: url(../assets/img/LogoCSA_Gris.png);
    background-size:80px 30px;
  }
  #customer5:hover{
    background-image: url(../assets/img/LogoCSA_Color.png);
    background-size:80px 30px;
    background-color: #5c565627;
  }
  #customer6{
    background-image: url(../assets/img/LogoCustosMobile_Gris.png);
    background-size:112px 112px;
  }
  #customer6:hover{
    background-image: url(../assets/img/LogoCustosMobile_Color.png);
    background-size:112px 112px;
  }
  #customer7{
    background-image: url(../assets/img/LogoEglobal_Gris.png);
    background-size:84px 23px;
  }
  #customer7:hover{
    background-image: url(../assets/img/LogoEglobal_Color.png);
    background-size:84px 23px;
  }
  #customer8{
    background-image: url(../assets/img/LogoExitusCredit_Gris.png);
    background-size:100px 22px;
  }
  #customer8:hover{
    background-image: url(../assets/img/LogoExitusCredit_Color.png);
    background-size:100px 22px;
  }
  #customer9{
    background-image: url(../assets/img/LogoExitusMujer_Gris.png);
    background-size:79px 45px;
  }
  #customer9:hover{
    background-image: url(../assets/img/LogoExitusMujer_Color.png);
    background-size:79px 45px;
  }
  #customer10{
    background-image: url(../assets/img/LogoExos_Gris.png);
    background-size:72px 30px;
  }
  #customer10:hover{
    background-image: url(../assets/img/LogoExos_Color.png);
    background-size:72px 30px;
  }
  #customer11{
    background-image: url(../assets/img/LogoIbillete_Gris.png);
    background-size:98px 24px;
  }
  #customer11:hover{
    background-image: url(../assets/img/LogoIbillete_Color.png);
    background-size:98px 24px;
  }
  /* #customer12 p{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 1.16px !important;
    font-size: 15px !important;
    line-height: 21px !important;
    text-align: center;
    color: #1D2B3C;
    justify-content: center;
    margin-top: 30%;

  } */
  #customer13{
    background-image: url(../assets/img/LogoVEQ_Gris.png);
    background-size:72px 61px;
  }
  #customer13:hover{
    background-image: url(../assets/img/LogoVEQ_Color.png);
    background-size:72px 61px;
  }
  /* #customer14 p{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 1.16px !important;
    font-size: 15px !important;
    line-height: 21px !important;
    text-align: center;
    color: #1D2B3C;
    justify-content: center;
    margin-top: 30%;
  } */
  #customer15{
    background-image: url(../assets/img/LogoVEQCapital_Gris.png);
    background-size:85px 39px;
  }
  #customer15:hover{
    background-image: url(../assets/img/LogoVEQCapital_Color.png);
    background-size:85px 39px;
  }
  #customer16{
    background-image: url(../assets/img/LogoMastercard_Gris.png);
    background-size:69px 56px;
  }
  #customer16:hover{
    background-image: url(../assets/img/LogoMastercard_Color.png);
    background-size:69px 56px;
  }
  #customer17{
    background-image: url(../assets/img/LogoProsa_Gris.png);
    background-size:85px 26px;
  }
  #customer17:hover{
    background-image: url(../assets/img/LogoProsa_Color.png);
    background-size:85px 26px;
  }
  #customer18{
    background-image: url(../assets/img/LogoTelmex_Gris.png);
    background-size:91px 14px;
  }
  #customer18:hover{
    background-image: url(../assets/img/LogoTelmex_Color.png);
    background-size:91px 14px;
  }
  #customer19{
    background-image: url(../assets/img/LogoUbuken_Gris.png);
    background-size:84px 29px;
  }
  #customer19:hover{
    background-image: url(../assets/img/LogoUbuken_Color.png);
    background-size:84px 29px;
  }
  #customer20{
    background-image: url(../assets/img/LogoWeConnect_Gris.png);
    background-size:90px 10px;
  }
  #customer20:hover{
    background-image: url(../assets/img/LogoWeConnect_Color.png);
    background-size:90px 10px;
  }
  #customer21{
    background-image: url(../assets/img/LogoWhitecarrot_Gris.png);
    background-size:90px 38px;
  }
  #customer21:hover{
    background-image: url(../assets/img/LogoWhitecarrot_Color.png);
    background-size:90px 38px;
  }
  #customer22{
    background-image: url(../assets/img/LogoXbatt_Gris.png);
    background-size:84px 42px;
  }
  #customer22:hover{
    background-image: url(../assets/img/LogoXbatt_Color.png);
    background-size:84px 42px;
  }
   #customer23{
    background-image: url(../assets/img/LogoPROASA_Gris.png);
    background-size:104px 34px;
  }
  #customer23:hover{
    background-image: url(../assets/img/LogoPROASA_Color.png);
    background-size:104px 34px;
  }
  #customer24{
    background-image: url(../assets/img/LogoSportsCapital_Gris.png);
    background-size:78px 62px;
  }
  #customer24:hover{
    background-image: url(../assets/img/LogoSportsCapital_Color.png);
    background-size:78px 62px;
  }
  #customer25{
    background-image: url(../assets/img/LogoWomenInvestment_Gris.png);
    background-size:86px 42px;
  }
  #customer25:hover{
    background-image: url(../assets/img/LogoWomenInvestment_Color.png);
    background-size:86px 42px;
  }
  #customer26{
  background-image: url(../assets/img/BNDCR-G.png);
  background-size:85px 33px;
  }
  #customer26:hover{
    background-image: url(../assets/img/BNDCR-C.png);
    background-size:85px 33px;
  }
  #customer27{
    background-image: url(../assets/img/ConceptoMovil-G.png);
    background-size:108px 22px;
  }
  #customer27:hover{
    background-image: url(../assets/img/ConceptoMovil-C.png);
    background-size:108px 22px;
  }
  #customer28{
    background-image: url(../assets/img/Egesio-G.png);
    background-size:76px 46px;
  }
  #customer28:hover{
    background-image: url(../assets/img/Egesio-C.png);
    background-size:76px 46px;
  }
  #customer29{
    background-image: url(../assets/img/ExitusForce-G.png);
    background-size:76px 38px;
  }
  #customer29:hover{
    background-image: url(../assets/img/ExitusForce-C.png);
    background-size:76px 38px;
  }
  #customer30{
    background-image: url(../assets/img/LaCasaDeToño-G.png);
    background-size:72px 48px;
  }
  #customer30:hover{
    background-image: url(../assets/img/LaCasaDeToño-C.png);
    background-size:72px 48px;
  }
}

@media screen and (max-width: 1800px) and (min-width: 961px){

  .title-section-c{

    font-family: 'Gotham Light Regular';
    letter-spacing: 1.54px !important;
    font-size: 20px !important;
    line-height: 28px !important;
    text-align: center;
    color: #1D2B3C;
    color: #1D1D1D;
  }
  .content-section{

    font-family: 'Gotham Book Regular';
    letter-spacing: 1.54px !important;
    font-size: 20px !important;
    line-height: 28px !important;
    text-align: center;
    color: #1D1D1D;
  }

  .div-customers-t{
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
  }

  .customer{
    width: 250px;
    height: 100px;
    background-repeat: no-repeat;
    background-position:center;
    align-content: center;
  }
  #customer1{
    background-image: url(../assets/img/Logo2Tor_Gris.png);
    background-size:68px 68px;
    /* background-color: red; */
  }
  #customer1:hover{
    background-image: url(../assets/img/Logo2Tor_Color.jpg);
    background-size:68px 68px;
  }
  #customer2{
    background-image: url(../assets/img/LogoAruba_Gris.png);
    background-size:101px 28px;
  }
  #customer2:hover{
    background-image: url(../assets/img/LogoAruba_Color.png);
    background-size:101px 28px;
  }
  #customer3{
    background-image: url(../assets/img/LogoBeSchool_Gris.png);
    background-size:60px 60px;
  }
  #customer3:hover{
    background-image: url(../assets/img/LogoBeSchool_Color.png);
    background-size:60px 60px;
  }
  #customer4{
    background-image: url(../assets/img/LogoChefTete_Gris.png);
    background-size:140px 39px;
  }
  #customer4:hover{
    background-image: url(../assets/img/LogoChefTete_Color.png);
    background-size:140px 39px;
  }
  #customer5{
    background-image: url(../assets/img/LogoCSA_Gris.png);
    background-size:80px 30px;
  }
  #customer5:hover{
    background-image: url(../assets/img/LogoCSA_Color.png);
    background-size:80px 30px;
    background-color: #5c565627;
  }
  #customer6{
    background-image: url(../assets/img/LogoCustosMobile_Gris.png);
    background-size:135px 135px;
  }
  #customer6:hover{
    background-image: url(../assets/img/LogoCustosMobile_Color.png);
    background-size:135px 135px;
  }
  #customer7{
    background-image: url(../assets/img/LogoEglobal_Gris.png);
    background-size:111px 31px;
  }
  #customer7:hover{
    background-image: url(../assets/img/LogoEglobal_Color.png);
    background-size:111px 31px;
  }
  #customer8{
    background-image: url(../assets/img/LogoExitusCredit_Gris.png);
    background-size:103px 23px;
  }
  #customer8:hover{
    background-image: url(../assets/img/LogoExitusCredit_Color.png);
    background-size:103px 23px;
  }
  #customer9{
    background-image: url(../assets/img/LogoExitusMujer_Gris.png);
    background-size:107px 60px;
  }
  #customer9:hover{
    background-image: url(../assets/img/LogoExitusMujer_Color.png);
    background-size:107px 60px;
  }
  #customer10{
    background-image: url(../assets/img/LogoExos_Gris.png);
    background-size:84px 35px;
  }
  #customer10:hover{
    background-image: url(../assets/img/LogoExos_Color.png);
    background-size:84px 35px;
  }
  #customer11{
    background-image: url(../assets/img/LogoIbillete_Gris.png);
    background-size:114px 28px;
  }
  #customer11:hover{
    background-image: url(../assets/img/LogoIbillete_Color.png);
    background-size:114px 28px;
  }
  /* #customer12 p{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 1.54px !important;
    font-size: 20px !important;
    line-height: 28px !important;
    text-align: center;
    color: #1D2B3C;
    justify-content: center;
    margin-top: 20%;

  } */
  #customer13{
    background-image: url(../assets/img/LogoVEQ_Gris.png);
    background-size:84px 72px;
  }
  #customer13:hover{
    background-image: url(../assets/img/LogoVEQ_Color.png);
    background-size:84px 72px;
  }
  #customer14 p{
    font-family: 'Gotham Bold Regular';
    letter-spacing: 1.54px !important;
    font-size: 20px !important;
    line-height: 28px !important;
    text-align: center;
    color: #1D2B3C;
    justify-content: center;
    margin-top: 20%;
  }
  #customer15{
    background-image: url(../assets/img/LogoVEQCapital_Gris.png);
    background-size:121px 55px;
  }
  #customer15:hover{
    background-image: url(../assets/img/LogoVEQCapital_Color.png);
    background-size:121px 55px;
  }
  #customer16{
    background-image: url(../assets/img/LogoMastercard_Gris.png);
    background-size:80px 66px;
  }
  #customer16:hover{
    background-image: url(../assets/img/LogoMastercard_Color.png);
    background-size:80px 66px;
  }
  #customer17{
    background-image: url(../assets/img/LogoProsa_Gris.png);
    background-size:110px 33px;
  }
  #customer17:hover{
    background-image: url(../assets/img/LogoProsa_Color.png);
    background-size:110px 33px;
  }
  #customer18{
    background-image: url(../assets/img/LogoTelmex_Gris.png);
    background-size:112px 17px;
  }
  #customer18:hover{
    background-image: url(../assets/img/LogoTelmex_Color.png);
    background-size:112px 17px;
  }
  #customer19{
    background-image: url(../assets/img/LogoUbuken_Gris.png);
    background-size:126px 44px;
  }
  #customer19:hover{
    background-image: url(../assets/img/LogoUbuken_Color.png);
    background-size:126px 44px;
  }
  #customer20{
    background-image: url(../assets/img/LogoWeConnect_Gris.png);
    background-size:150px 15px;
  }
  #customer20:hover{
    background-image: url(../assets/img/LogoWeConnect_Color.png);
    background-size:150px 15px;
  }
  #customer21{
    background-image: url(../assets/img/LogoWhitecarrot_Gris.png);
    background-size:111px 48px;
  }
  #customer21:hover{
    background-image: url(../assets/img/LogoWhitecarrot_Color.png);
    background-size:111px 48px;
  }
  #customer22{
    background-image: url(../assets/img/LogoXbatt_Gris.png);
    background-size:119px 52px;
  }
  #customer22:hover{
    background-image: url(../assets/img/LogoXbatt_Color.png);
    background-size:119px 52px;
  }

  #customer23{
    background-image: url(../assets/img/LogoPROASA_Gris.png);
    background-size:146px 47px;
  }
  #customer23:hover{
    background-image: url(../assets/img/LogoPROASA_Color.png);
    background-size:146px 47px;
  }
  #customer24{
    background-image: url(../assets/img/LogoSportsCapital_Gris.png);
    background-size:82px 65px;
  }
  #customer24:hover{
    background-image: url(../assets/img/LogoSportsCapital_Color.png);
    background-size:82px 65px;
  }
  #customer25{
    background-image: url(../assets/img/LogoWomenInvestment_Gris.png);
    background-size:107px 53px;
  }
  #customer25:hover{
    background-image: url(../assets/img/LogoWomenInvestment_Color.png);
    background-size:107px 53px;
  }
  #customer26{
    background-image: url(../assets/img/BNDCR-G.png);
    background-size:103px 40px;
  }
  #customer26:hover{
    background-image: url(../assets/img/BNDCR-C.png);
    background-size:103px 40px;
  }
  #customer27{
    background-image: url(../assets/img/ConceptoMovil-G.png);
    background-size:142px 30px;
  }
  #customer27:hover{
    background-image: url(../assets/img/ConceptoMovil-C.png);
    background-size:142px 30px;
  }
  #customer28{
    background-image: url(../assets/img/Egesio-G.png);
    background-size:97px 59px;
  }
  #customer28:hover{
    background-image: url(../assets/img/Egesio-C.png);
    background-size:97px 59px;
  }
  #customer29{
    background-image: url(../assets/img/ExitusForce-G.png);
    background-size:98px 49px;
  }
  #customer29:hover{
    background-image: url(../assets/img/ExitusForce-C.png);
    background-size:98px 49px;
  }
  #customer30{
    background-image: url(../assets/img/LaCasaDeToño-G.png);
    background-size:90px 60px;
  }
  #customer30:hover{
    background-image: url(../assets/img/LaCasaDeToño-C.png);
    background-size:90px 60px;
  }
}
</style>